// Vite doesn't define window as global, so applying as suggested here: https://stackoverflow.com/a/73208485/26180
// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
window.global ||= window;

export {};
